import { useParams } from "@tanstack/react-router";
import { VenueDetailsFallback } from "./VenueDetailsFallback";

export function VenueDetailsErrorBoundary() {
  const params = useParams({ strict: false }) as { venueId?: string };
  return <VenueDetailsFallback slug={params?.venueId ?? "venue"} />;
}
